/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function RoleAdmin({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.4 7a2.6 2.6 0 1 1 5.2 0 2.6 2.6 0 0 1-5.2 0ZM8 5.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M8 .4a.596.596 0 0 1 .564.394.597.597 0 0 1 .03.118c.107.593 1.115 2.341 4.926 2.48.582.02 1.08.493 1.08 1.108v2.734a8.6 8.6 0 0 1-5.88 8.159l-.525.174a.599.599 0 0 1-.39 0l-.525-.174a8.6 8.6 0 0 1-5.88-8.16V4.5c0-.615.498-1.087 1.08-1.109C6.29 3.253 7.3 1.505 7.406.911a.597.597 0 0 1 .39-.475A.596.596 0 0 1 8 .4Zm0 1.98c-.812 1.06-2.487 2.085-5.4 2.208v2.646c0 1.945.76 3.756 2.04 5.102C5.21 11.21 6.198 10.4 7.393 10.4h1.214c1.195 0 2.182.81 2.753 1.936a7.396 7.396 0 0 0 2.04-5.102V4.588C10.487 4.465 8.812 3.44 8 2.38Zm2.421 10.788c-.418-1.047-1.148-1.568-1.814-1.568H7.393c-.666 0-1.396.52-1.815 1.568a7.39 7.39 0 0 0 2.082 1.086l.34.114.34-.114a7.39 7.39 0 0 0 2.082-1.086Z" clipRule="evenodd" /></svg>;
}
;